import React from 'react';
import { useTranslation } from 'react-i18next';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { getSafeTranslation } from '../../../../../../utils/language';
import { getLatestVersionWidgetFormSchema } from '../../../../../../utils/widgets';

const NoHistoryWidgetValueError = ({ dataPath, widgetType, date }) => {
  const { t: translate } = useTranslation();
  const formSchema = getLatestVersionWidgetFormSchema(widgetType);

  const title = _.getNonEmpty(formSchema, 'title');
  const property = _.getNonEmpty(formSchema, `properties.${dataPath}.title`);

  return (
    <div className={'text-color-red text-normal-wrap'}>
      {translate('widget:calculationError.noHistoryWidgetValueMessage', {
        property: getSafeTranslation(property),
        widget: getSafeTranslation(title),
        date
      })}
    </div>
  );
};

NoHistoryWidgetValueError.propTypes = {
  dataPath: PropTypes.string.isRequired,
  widgetType: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired
};

export default NoHistoryWidgetValueError;
